// extracted by mini-css-extract-plugin
export default {"card-stack-desc-wrapper":"card-stack-desc-wrapper_Fn0pg","button-group":"button-group_fhi08","timeline":"timeline_hncC5"};